import { createContext } from 'react';

export const HeaderContext = createContext({
  visible: true,
  toggle: (_show) => {},
});
